// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"abf86ad9","681":"48232e99"}[chunkId] + ".chunk.css";
};